export const SafeJson = (() => {
    const stringify = (sth) => {
        try {
            return JSON.stringify(sth);
        }
        catch (e) {
            console.error(e);
            return `JSON stringify Error: ${e.message}`;
        }
    };
    const parse = (sth) => {
        try {
            return JSON.parse(sth || '');
        }
        catch (e) {
            console.error(e);
            return null;
        }
    };
    return {
        stringify,
        parse,
    };
})();
